import { useGetMeQuery } from '../redux-fetch/apiImpersonation'
import { MeResponse } from '../../features/CommonSettings/Impersonation/types'

// E11 (WI 611) — the session-aware /api/v1/me. Unlike ILoggedInUser (/user/me, which has no isGlobalAdmin),
// MeResponse carries the top-level isGlobalAdmin the impersonation grants route guards on, plus the active
// persona used to default the New Grant grantee to 'Self'. R2's ImpersonationBanner reuses this hook for the
// active-session summary (target + expiry).
export const useMe = () => {
  const { data, isLoading, isFetching, isSuccess, isError } = useGetMeQuery()

  const me = data as MeResponse | undefined

  return {
    me,
    isGlobalAdmin: Boolean(me?.isGlobalAdmin),
    // The active impersonation summary (target + expiry), or null when no session is live. The E9 middleware
    // Stage 4 only populates it once a session is started, so it stays null until the E11 cutover.
    impersonation: me?.impersonation ?? null,
    isImpersonating: me?.impersonation != null,
    isLoading,
    isFetching,
    isSuccess,
    isError,
  }
}

export default useMe
